<!-- <div class="main-container" > -->
    <div  class="page-layout blank fullwidth" (scroll)="onScroll()" fusePerfectScrollbar style="height: 1px; overflow-y: scroll; margin-bottom: 5em;    top: 1px;    background: linear-gradient(45deg, #e2e8f8, #F8FAFF);" >
        <div class="first-div">
            <!-- <div class="container" (window:scroll)="onScroll()"> -->
            <div class="container">
                <!-- <div class="left">
                    <div class="offer" style="text-align: left;" *ngIf="data.discount>0">{{discountType}} off</div>
                    <img [src]="data.imageUrl" alt="Product Image" [ngClass]="{'imgMobile': isMobile}" onerror="this.src='../../../../assets/images/logos/logo.png'; this.classList.add('fallback-logo')" 
                    >
                    <div class="sku-tags">       
                        <span *ngIf="previouslyBought" class="sku-tag-top-right previously-bought tag" [class.animate]="showAnimation">
                            Previously Bought
                        </span>   
                        <span *ngIf="!previouslyBought && orderedCount > 0" class="sku-tag-top-right ordered-count tag " [class.animate]="showAnimation">
                            {{ orderedCount }} {{ orderedCount === 1 ? 'Unit' : 'Units' }} Sold
                        </span>
                        <span *ngIf="!previouslyBought && orderedCount === 0 && garageCount > 0" class="sku-tag-top-right garage-count tag ordered-count" [class.animate]="showAnimation">
                            Bought by {{ garageCount }} Garages
                        </span>
                    </div>
                </div> -->

                <div class="left">
                    <!-- <div class="sub-left"> -->
                        <div class="offer" style="text-align: left;" *ngIf="data.discount > 0">{{discountType}} off</div>              
                        <!-- Main Image -->
                        <img [src]="selectedImage || data.imageUrl" alt="Product Image" 
                            [ngClass]="{'imgMobile': isMobile}" 
                            onerror="this.src='../../../../assets/images/logos/logo.png'; this.classList.add('fallback-logo')" >
                        <div class="sku-tags">
                            <span *ngIf="previouslyBought" class="sku-tag-top-right previously-bought tag" [class.animate]="showAnimation">
                                Previously Bought
                            </span>
                            <span *ngIf="!previouslyBought && orderedCount > 0" class="sku-tag-top-right ordered-count tag " [class.animate]="showAnimation">
                                {{ orderedCount }} {{ orderedCount === 1 ? 'Unit' : 'Units' }} Sold
                            </span>
                            <span *ngIf="!previouslyBought && orderedCount === 0 && garageCount > 0" class="sku-tag-top-right garage-count tag ordered-count" [class.animate]="showAnimation">
                                Bought by {{ garageCount }} Garages
                            </span>
                        </div>
                    <!-- </div> -->
                    <!-- Thumbnails -->
                    <div class="thumb-wrapper" *ngIf="data.imageUrls?.length > 0">
        
                        <!-- Left Arrow -->
                        <button class="arrow arrow-left" (click)="scrollThumbnails('left')"  *ngIf="showLeftArrow">
                            <mat-icon>arrow_back_ios</mat-icon>
                        </button>

                        <!-- Thumbnails -->
                        <div class="thumbnails" #thumbnailContainer>
                            <img *ngFor="let img of data.imageUrls"
                                [src]="img"
                                class="thumbnail-image"
                                [class.selected]="img === selectedImage"
                                (click)="selectedImage = img"
                                alt="Thumbnail">
                        </div>

                        <!-- Right Arrow -->
                        <button class="arrow arrow-right" (click)="scrollThumbnails('right')"  *ngIf="showRightArrow">
                            <mat-icon>arrow_forward_ios</mat-icon>
                        </button>

                    </div>

                </div>


                <div [ngClass]="isMobile ? 'rightMobile' : 'right'">
                    <div class="top-right">                    
                        <div class="partname">
                            <div class="partname-text"><span class="partname-text">{{ data.name }}</span></div>
                            <div *ngIf="dataplannedSku===1">
                                    <img src="../../../../assets/images/assured/assured.png" alt="assured" style="max-width: 15%;margin-bottom: 3px;">
                                
                            </div>  
                            
                            <div class="ratings">
                                <i class="material-icons star-icons">star</i>
                                <i class="material-icons star-icons">star</i>
                                <i class="material-icons star-icons">star</i>
                                <i class="material-icons star-icons">star</i>
                                <i class="material-icons star-icons">star</i>5 Ratings
                            </div>    
                            <!-- <div class="delivery-time">
                                <img src="../../../../assets/images/productdetailsimage/delivery.png" style="margin-right: 4px;">{{data.deliveryTime}}
                            </div>   -->

                            <div class="info-sec">
                                <div class="info1">
                                    <div class="price" *ngIf="data.sellingPrice > 0">
                                        <span class="mrp" style="font-weight: bold;font-size: 22px; color: #0D4C92;"> ₹{{ data.sellingPrice | number }}</span>
                                        <span class="line-through"> ₹{{ data.mrp | number }}</span>
                                        
                                <!-- <div class="info3"> -->
                                    <span class="save" style="color: #D4AF37;margin-left: 10px;">
                                        <img src="../../../../assets/images/productdetailsimage/save.png" style="margin: 10px;">
                                        <span>Save ₹
                                        <span class="bold">{{data.discount  | number:'1.2-2'}}</span> </span>
                                    </span>
                                    <!-- <div class="free-delivery">
                                        <i class="material-icons">local_shipping</i>{{ data.deliveryStatus }}
                                    </div> -->
                                <!-- </div> -->
                                    </div>
                                    <div class="price" *ngIf="data.sellingPrice <= 0"  style="font-weight: bold;font-size: 22px; color: #0D4C92;">
                                        MRP:<span class="bold"> ₹{{ data.mrp | number }}</span>
                                    </div>
                                </div>
                                <div class="info2">
                                    <div class="inclusive" style="color: #6E7582;">Inclusive of all taxes</div>

                                </div>
                            </div>  
                            
                            <!-- AVAILABLE STATE -->
                            <div class="asp-availability-card asp-availability-card--available" *ngIf="isAvailable">
                            <div class="asp-avail-header">
                                <div class="asp-avail-icon">
                                <mat-icon>check</mat-icon>
                                </div>
                                <div class="asp-avail-headline">
                                <span class="asp-avail-title">Available — Ready to Dispatch</span>
                                <div class="asp-avail-subtext">
                                        Available from Autoverse or a trusted Bengaluru supply partner.
                                    </div>
                                </div>
                                <span class="asp-avail-badge">
                                <span class="asp-avail-dot"></span>Stock Verified Recently
                                </span>
                            </div>
                            </div>

                            <!-- CONFIRMING AVAILABILITY STATE -->
                            <div class="asp-availability-card asp-availability-card--confirming" *ngIf="!isAvailable">
                            <div class="asp-avail-header">
                                <div class="asp-avail-icon asp-avail-icon--pending">
                                <mat-icon>schedule</mat-icon>
                                </div>
                                <div class="asp-avail-confirm-prnt">
                                    <span class="asp-avail-title asp-avail-title--pending">Confirming Availability</span>
                                    <div class="asp-avail-subtext asp-avail-subtext--pending">
                                        We'll confirm availability and ETA.
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="oes-save-box" *ngIf="data?.alternate?.length !==0 && data?.alternate !==null ">
                    <div class="left-save-box">
                        <div class="icon">
                            <img src="../../../../assets/images/productdetailsimage/oes-save.png">
                        </div>
                        <div class="text">
                        <div class="title">OES Save More</div>
                        <div class="subtitle">Get additional discounts on bulk orders</div>
                        </div>
                    </div>

                    <button class="learn-btn" (click)="saveMore()">Learn More</button>
                    </div>
                    <ng-container *ngIf="!isAvailable && !isMobile">
                        <button *ngIf="wishlistList.length<=0" (click)="addToRequestWishlist(data)" class="asp-wishlist-btn">
                            <mat-icon>favorite_border</mat-icon> Add to Request Wishlist
                        </button>
                        <button *ngIf="wishlistList.length>0 && !wishlistList[0][data.key]" (click)="addToRequestWishlist(data)" class="asp-wishlist-btn">
                            <mat-icon>favorite_border</mat-icon> Add to Request Wishlist
                        </button>

                        <div class="addtocartcompatiblecar1" *ngIf="wishlistList[0] && wishlistList[0][data.key]">
                            <div class="spare-add-cart1">
                            <div class="btn-group" *ngIf="data.key==wishlistList[0][data.key].key && wishlistList[0][data.key].cart_qty>0">
                                <button class="button1" mat-raised-button (click)="removeWishlistItem(wishlistList[0][data.key].cart_qty, data.key)">
                                <mat-icon class="sidebuttons1">remove</mat-icon>
                                </button>
                                <input type="text" [(ngModel)]="wishlistList[0][data.key].cart_qty" readonly>
                                <button class="button1" mat-raised-button (click)="addWishlistItem(wishlistList[0][data.key].cart_qty, data.key)">
                                <mat-icon class="sidebutton1">add</mat-icon>
                                </button>
                            </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!isMobile && isAvailable " >
                        <button *ngIf="cartList.length<=0"  [ngClass]="isMobile ? 'add-to-cartMobile' : 'add-to-cart'" (click)="addCart(1)" > <mat-icon>add</mat-icon> ADD TO CART</button>
                        <button #addButton *ngIf="cartList.length>0 && !cartList[0][data.key] && !isMobile" [ngClass]="isMobile ? 'add-to-cartMobile' : 'add-to-cart'"(click)="addCart(1)"><mat-icon>add</mat-icon>Add to Cart</button>
                    </ng-container>
                    <div class="addtocartcompatiblecar"*ngIf=" isAvailable &&cartList[0] && cartList[0][data.key] && !isMobile">
                        <div class="spare-add-cart" style="width: 100%;">
                            <div class="btn-group" *ngIf="data.key==cartList[0][data.key].key && cartList[0][data.key].cart_qty>0">
                                <button mat-raised-button (click)="removeItem(cartList[0][data.key].cart_qty, data.key)">
                                    <mat-icon class="sidebuttons">remove</mat-icon>
                                </button>
                                <input type="text" [(ngModel)]="cartList[0][data.key].cart_qty" readonly >
                                <button mat-raised-button (click)="addItem(cartList[0][data.key].cart_qty, data.key)">
                                    <mat-icon class="sidebutton">add</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <button  (click)="scrollToCompatibility()" [ngClass]="isMobile ? 'compatible-carsMobile' : 'compatible-cars'">
                        <div class="data.description" >
                            <div ><img src="../../../../assets/images/productdetailsimage/car.png" style="margin-right: 10px;">Check Compatible Cars</div>
                        </div>
                    </button>
                   
                    <div  [ngClass]="isMobile ? 'button-containerMobile' : 'button-container'">
                        <div [ngClass]="isMobile ? 'button-wrapperMobile' : 'button-wrapper'">
                            <!-- <button *ngIf="cartList.length<=0" class="add-to-cart" (click)="addCart(data, 1)" >ADD TO CART</button>
                            <button *ngIf="cartList.length>0 && !cartList[0][data.key]" class="add-to-cart" (click)="addCart(data, 1)">Add to Cart</button> -->
                            <!-- <button *ngIf="cartList.length<=0" class="add-to-cart" (click)="addCart(data, 1)" >ADD TO CART</button>
                            <button *ngIf="cartList.length>0 && !cartList[0][data.key]" class="add-to-cart" (click)="addCart(data, 1)">Add to Cart</button> -->
                         
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="availability-box">
        <div class="availability-left">
            <div class="icon">
                <mat-icon> location_on</mat-icon>
            </div>

            <div class="text">
            <div class="title">Check Physical Availability Near You</div>
            <div class="subtitle">
                Find the nearest Autoverse store with this product in stock
            </div>
            </div>
        </div>

        <button class="check-btn" (click)="openPopup()">Check Availability</button>
        </div>
<!-- Overlay -->
<div class="popup-overlay" *ngIf="showPopup" (click)="closePopup()"></div>

<!-- Popup -->
<div class="popup-container" *ngIf="showPopup">
  <div class="popup-header">
    <div>
    <h2><img src="../../../../assets/images/productdetailsimage/warehouse.png">Physical Availability Across Autoverse Warehouses</h2>
    <p>See what's physically available right now. Orders will always be fulfilled from your assigned warehouse.</p>
    </div>
    <button class="close-btn" (click)="closePopup()">✕</button>
  </div>

  <!-- CASE 1: Assigned warehouse has stock -->
  <ng-container *ngIf="hasStockInAssigned">
    <div class="assigned-card available">
      <div class="top-row">
        <span class="title">Your Assigned Warehouse ⭐</span>
        <span class="status available">
        <img src="../../../../assets/images/productdetailsimage/right.png">Available
      </span>
      </div>

      <h3>{{ assignedWarehouseName }}</h3>

      <div class="count-box">{{ assignedWarehouseStock }} </div>
      <p style="margin-top:0;color: #6D6D6D;">Physical Stock</p>

      <p class="small-info">Available for immediate processing</p>
    </div>
<div class="divider-with-text">
  <span>Stock in Other Autoverse Warehouses</span>
</div>


<div class="warehouse-list">

  <div class="warehouse-card" *ngFor="let w of data.warehouseStock" 
       [ngClass]="{ 'out-stock-card': w.stock <= 0  }">

    <!-- Left Section -->
    <div class="left-card">
      <div class="dot" [ngClass]="w.stock <= 0  ? 'dot-out' : 'dot-available'"></div>

      <div class="name-badges">
        <span class="warehouse-name">{{ w.name }}</span>

        <!-- Badges -->
        <span *ngIf="w.badge === 'highest'" class="badge highest">⭐ Highest Availability</span>
        <span *ngIf="w.badge === 'limited'" class="badge limited">⚠️ Limited Qty</span>
      </div>
    </div>

    <!-- Right Section -->
    <div class="right-card">
    <div>
      <span class="count" *ngIf="w.stock >0">{{ w.stock }}</span>
      <span class="count" *ngIf="w.stock <=0">0</span>
      <span class="units-text">Units</span>
    </div>
     <span class="status available" *ngIf="w.stock > 0">
        <img src="../../../../assets/images/productdetailsimage/right.png">Available
      </span>
      <span class="status out"   *ngIf="w.stock <= 0">
        <img src="../../../../assets/images/productdetailsimage/wrong.png">Out of Stock
      </span>
    </div>

  </div>

</div>


    <div class="success-box">
        <img src="../../../../assets/images/productdetailsimage/check.png">
        <div>
            <p style="font-weight: bold;">Good News!</p>
            <p style="font-size: 10px;"> This part is unavailable in your warehouse but available in other Autoverse warehouses. </p>
        </div>
    </div>
  </ng-container>

  <!-- CASE 2: Assigned has 0 but other warehouses have stock -->
  <ng-container *ngIf="!hasStockInAssigned && hasStockInOther">
    <div class="assigned-card unavailable">
      <div class="top-row">
        <span class="title">Your Assigned Warehouse ⭐</span>
        <span class="status unavailable"><img src="../../../../assets/images/productdetailsimage/wrong.png">Unavailable Right Now</span>
      </div>

      <h3>{{ assignedWarehouseName }}</h3>

      <div class="count-box zero">{{ assignedWarehouseStock }} </div>
      <p style="margin-top:0;color: #6D6D6D;">Physical Stock</p>

      <p class="warning-text">
        This part is not available in your assigned warehouse right now.
      </p>
      <p class="othergarage">Orders from your garage are fulfilled here.</p>
    </div>

    <div class="divider-with-text">
  <span>Stock in Other Autoverse Warehouses</span>
</div>


<div class="warehouse-list">

  <div class="warehouse-card" *ngFor="let w of data.warehouseStock" 
       [ngClass]="{ 'out-stock-card': w.stock <= 0  }">

    <!-- Left Section -->
    <div class="left-card">
      <div class="dot" [ngClass]="w.stock <= 0 ? 'dot-out' : 'dot-available'"></div>

      <div class="name-badges">
        <span class="warehouse-name">{{ w.name }}</span>

        <!-- Badges -->
        <span *ngIf="w.badge === 'highest'" class="badge highest">⭐ Highest Availability</span>
        <span *ngIf="w.badge === 'limited'" class="badge limited">⚠️ Limited Qty</span>
      </div>
    </div>

    <!-- Right Section -->
    <div class="right-card">
    <div>
      <span class="count" *ngIf="w.stock >0">{{ w.stock }}</span>
      <span class="count" *ngIf="w.stock <=0">0</span>
      <span class="units-text">Units</span>
    </div>
     <span class="status available" *ngIf="w.stock > 0">
        <img src="../../../../assets/images/productdetailsimage/right.png">Available
      </span>
      <span class="status out"   *ngIf="w.stock <= 0">
        <img src="../../../../assets/images/productdetailsimage/wrong.png">Out of Stock
      </span>
    </div>

  </div>

</div>


    <div class="success-box">
        <img src="../../../../assets/images/productdetailsimage/check.png">
        <div>
            <p style="font-weight: bold;">Good News!</p>
            <p style="font-size: 10px;"> This part is unavailable in your warehouse but available in other Autoverse warehouses. </p>
        </div>
    </div>
  </ng-container>

  <!-- CASE 3: No stock anywhere -->
  <ng-container *ngIf="noStockAnywhere">
    <div class="assigned-card unavailable">
      <div class="top-row">
        <span class="title">Your Assigned Warehouse ⭐</span>
        <span class="status unavailable"><img src="../../../../assets/images/productdetailsimage/wrong.png">Unavailable Right Now</span>
      </div>

      <h3>{{ assignedWarehouseName }}</h3>

      <div class="count-box zero">{{ assignedWarehouseStock }}</div>
      <p style="margin-top:0;color: #6D6D6D;">Physical Stock</p>

      <p class="nostock-text"><i>info</i>This part is currently not in stock in any Autoverse warehouse.</p>
    </div>
<div class="divider-with-text">
  <span>Stock in Other Autoverse Warehouses</span>
</div>

<div class="warehouse-list">

  <div class="warehouse-card" *ngFor="let w of data.warehouseStock" 
       [ngClass]="{ 'out-stock-card': w.stock <= 0  }">

    <!-- Left Section -->
    <div class="left-card">
      <div class="dot" [ngClass]="w.stock <= 0  ? 'dot-out' : 'dot-available'"></div>

      <div class="name-badges">
        <span class="warehouse-name">{{ w.name }}</span>

        <!-- Badges -->
        <span *ngIf="w.badge === 'highest'" class="badge highest">⭐ Highest Availability</span>
        <span *ngIf="w.badge === 'limited'" class="badge limited">⚠️ Limited Qty</span>
      </div>
    </div>

    <!-- Right Section -->
    <div class="right-card">
    <div>
      <span class="count" *ngIf="w.stock >0">{{ w.stock }}</span>
      <span class="count" *ngIf="w.stock <=0">0</span>
      <span class="units-text">Units</span>
    </div>
      <span class="status available" *ngIf="w.stock > 0">
        <img src="../../../../assets/images/productdetailsimage/right.png">Available
      </span>
      <span class="status out"   *ngIf="w.stock <= 0">
        <img src="../../../../assets/images/productdetailsimage/wrong.png">Out of Stock
      </span>
    </div>

  </div>

</div>


    <div class="no-stock-box">
      <img src="../../../../assets/images/productdetailsimage/nostock.png">
      <h3>No Stock Available Right Now</h3>
      <p>This part is temporarily unavailable across the entire Autoverse network.</p>
    </div>
  </ng-container>
</div>
        <div class="spec-section">
  <h2>Product Specifications</h2>

  <div class="spec-container">

    <!-- LEFT CARD -->
    <div class="spec-card" *ngIf="type !== 'kit'">
      <div class="spec-row">
        <div class="label">
           <img src="../../../../assets/images/productdetailsimage/brand.png"> Brand
        </div>
        <div class="value">{{ data?.brand?.name }}</div>
      </div>

      <div class="spec-row">
        <div class="label">
           <img src="../../../../assets/images/productdetailsimage/parttype.png"> Part Type
        </div>
        <div class="value">{{ data.partType }}</div>
      </div>

      <div class="spec-row">
        <div class="label">
          <img src="../../../../assets/images/productdetailsimage/partno.png"> Part Number
        </div>
        <div class="value">{{ data.partNumber }}</div>
      </div>
    </div>

    <!-- SERVICE KIT VIEW -->
    <div class="spec-card" *ngIf="type === 'kit'">

    <div class="spec-row" *ngFor="let item of data?.kitItems">
        <div class="label">
        {{ getKitLabel(item.partName) }}
        </div>
        <div class="value">
        {{ item.brandName }}
        </div>
    </div>

    </div>


    <!-- RIGHT CARD -->
    <div class="spec-card" *ngIf="type !== 'kit'">
      <div class="spec-row">
        <div class="label">
           <img src="../../../../assets/images/productdetailsimage/cat.png"> Category
        </div>
        <div class="value">{{ data.category }}</div>
      </div>

      <div class="spec-row">
        <div class="label">
           <img src="../../../../assets/images/productdetailsimage/subcat.png"> Subcategory
        </div>
        <div class="value">{{ data.subCategory }}</div>
      </div>

      <div class="spec-row">
        <div class="label">
           <img src="../../../../assets/images/productdetailsimage/warranty.png"> Warranty
        </div>
        <div class="value">12 Months</div>
      </div>
    </div>

  </div>
</div>

         <div class="bottom-right">
                        <!-- <div class="saveMore" (click)="saveMore()" *ngIf="data?.alternate?.length !==0 && data?.alternate !==null ">
                            
                            <img src="../../../../assets/images/save-OES/Group 5830.png" class="Group"  alt="Group">
                            <img src="../../../../assets/images/save-OES/image 1682.png" class="image"  alt="image">
                        <img src="../../../../assets/images/save-OES/flywheel (1) 2.png" class="flywheel"  alt="flywheel">
                        
                        <p class="textOES">Choose OES Save More!</p>
                        <div class="highlight"></div>
                        <div class="subheadings-container">
                            
                            <div class="subheading">Save up to ₹{{ data.sellingPrice-minMrp |number}} more</div> 
                            <div class="subheading">Quality you can trust</div>
                            <div class="subheading">Prices you'll love</div>
                        </div>
                        </div> -->

                    </div>
        <div class="third-div" *ngIf="data.description || (whenIsItNeeded && whenIsItNeeded.length > 0)">
            <!-- <h3 style="font-weight: bold;"> Product Details</h3> -->
            <div class="product-details-tabs">
                <div class="tab"(click)="selectTab('data.description')" [ngClass]="{'active': activeTab === 'data.description'}">Description</div>
                <div class="tab" *ngIf="whenIsItNeeded && whenIsItNeeded.length > 0" (click)="selectTab('needed')" [ngClass]="{'active': activeTab === 'needed'}">When is it needed</div>
            </div>
            <div class="tab-content" *ngIf="activeTab === 'data.description'">
                <div [innerHtml]="data.description"></div>
            </div>
            <div class="tab-content" *ngIf="activeTab === 'needed' && whenIsItNeeded.length > 0">
                <ul>
                    <li *ngFor="let item of whenIsItNeeded" style="list-style: disc;">{{item}}</li>
                </ul>
            </div>
        </div>

    <div class="features-container">
        <h2 class="title">Why You Should Order From Autoverse</h2>


        <div class="features-row">
        <div class="feature-box">
        <img src="../../../../assets/images/productdetailsimage/genune.png" class="icon" />
        <h3>Genuine Products</h3>
        <p>100% authentic parts from authorized manufacturers with full warranty coverage</p>
        </div>


        <div class="feature-box">
        <img src="../../../../assets/images/productdetailsimage/fast.png" class="icon" />
        <h3>Fast Delivery</h3>
        <p>Express shipping options available with real-time tracking for your peace of mind</p>
        </div>


        <div class="feature-box">
        <img src="../../../../assets/images/productdetailsimage/expert.png" class="icon" />
        <h3>Expert Support</h3>
        <p>Professional assistance from certified technicians available for all queries</p>
        </div>
        </div>


        <div class="mini-features-row">
        <div class="mini-feature">
        <img src="../../../../assets/images/productdetailsimage/fastD.png" class="mini-icon" />
        <h4>Fast Delivery</h4>
        <span>Available</span>
        </div>


        <div class="mini-feature">
        <img src="../../../../assets/images/productdetailsimage/return.png" class="mini-icon" />
        <h4>Easy Returns</h4>
        <span>Fast Refunds</span>
        </div>


        <div class="mini-feature">
        <img src="../../../../assets/images/productdetailsimage/best.png" class="mini-icon" />
        <h4>Best Price</h4>
        <span>Competitive</span>
        </div>


        <div class="mini-feature">
        <img src="../../../../assets/images/productdetailsimage/quality.png" class="mini-icon" />
        <h4>Quality</h4>
        <span>Guaranteed</span>
        </div>
        </div>
    </div>


        <!-- <div class="fourth-div faq-container" *ngIf="data?.faqs?.length > 0">
            <h2 style="font-weight: bold;color: #0D4C92;">Frequently Asked Questions</h2>
            <div class="faq" *ngFor="let faq of data.faqs; let i = index">
                <div class="faq-item">
                    <input type="checkbox" id="faq{{i}}" class="faq-toggle">
                    <label for="faq{{i}}" class="question">
                        {{faq.question}}<span class="arrow">▼</span>
                    </label>
                    <div class="answer">
                        {{faq.answer}}
                    </div>
                </div>
            </div>
        </div> -->
        <div class="faq-container" *ngIf="data?.faqs?.length > 0">
            <h2 class="faq-title">Frequently Asked Questions</h2>

            <div class="faq-item" *ngFor="let item of data.faqs; let i = index" 
                (click)="toggleFAQ(i)">
                <div class="faq-question">
                {{ item.question }}
                <i class="arrows" [class.open]="openIndex === i">keyboard_arrow_down</i>
                </div>

                <div class="faq-answer" *ngIf="openIndex === i">
                {{ item.answer }}
                </div>
            </div>
        </div>

        <!-- <div class="cart" >
            <div class="cart-content">
                <div class="price-details">
                    <div class="partname"><span>{{ partName }}</span></div>
                    <div class="price" *ngIf="sellingPrice > 0">
                        <div style="display: flex;">
                            <span class="mrp"> selling price ₹{{ sellingPrice | number }}</span>
                            <div class="discount">{{discountType}} off</div>
                            <button *ngIf="cartList.length<=0" class="add-to-cart-last" (click)="addCart(data, 1)" >ADD TO CART</button>
                            <button *ngIf="cartList.length>0 && !cartList[0][data.key]" class="add-to-cart-last" (click)="addCart(data, 1)">Add to Cart</button>
                            <div *ngIf="cartList[0] && cartList[0][data.key]" style="background: #144579; padding: 7px;">
                                <div class="spare-add-cart" style="width: 100%;">
                                    <div class="btn-group" *ngIf="data.key==cartList[0][data.key].key && cartList[0][data.key].cart_qty>0">
                                        <button mat-raised-button (click)="removeItem(cartList[0][data.key].cart_qty, data.key)" style="background-color: #144579;"><mat-icon>remove</mat-icon></button>
                                        <input style="text-align: center;width: 100px;padding: 10px 1px 1px 1px;font-size: 15px;" type=text class="part-count" [(ngModel)]="cartList[0][data.key].cart_qty" readonly>
                                        <button mat-raised-button (click)="addItem(cartList[0][data.key].cart_qty, data.key)"style="background-color: #144579;"><mat-icon>add</mat-icon></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div> -->

        <div #compatabilityDiv *ngIf="type !== 'kit'">
            <div class="comapatable">
                <h3 class="faq-title">Check Compatibile Cars</h3>
                <mat-tab-group>
                <div *ngFor="let vehicle of compatability">
                    <mat-tab [label]="vehicle[0]">
                    <table  [ngClass]="isMobile ? 'toggle-comp-btnMobile' : 'toggle-comp-btn'">
                        <tr>
                        <th>Model</th>
                        <th>Fuel</th>
                        <th>Varient</th>
                        <th>Year</th>
                        </tr>
            
                        <tr *ngFor="let model of getVisibleModels(vehicle[1], vehicle[0]); let i = index">
                        <td>{{ model.model }}</td>
                        <td>{{ model.fuelType }}</td>
                        <td>{{ model.description }}</td>
                        <td>{{ model.yearFrom }}-{{ model.yearTo }}</td>
                        </tr>
                    </table>
                    <button (click)="toggleShowMore(vehicle[0])" 
                            [ngClass]="isMobile ? 'toggle-show-btnMobile' : 'toggle-show-btn'"
                            *ngIf="vehicle[1]?.length > 10" >
                        <div style="padding: 5px;">{{ showAllMap[vehicle[0]] ? 'Show Less' : 'Show More' }}</div>
                        <div style=" align-items: center; display: flex;">
                            <i class="material-icons" style="color: white">
                                {{ showAllMap[vehicle[0]] ? 'expand_less' : 'expand_more' }}
                            </i>
                        </div>
                    </button>
                    </mat-tab>
                </div>
                
                </mat-tab-group>
            </div>
        </div>

        <div class="bottom-fixed" *ngIf="!isMobile && showBottomDiv" >
            <div class="bottom-fixed-content">
                <!-- Image Section -->
                <img
                class="bottom-fixed-image"
                [src]="data.imageUrl || 'assets/images/default-image.jpg'"
                alt="Product Image"
                onerror="this.src='../../../../assets/images/logos/logo.png'; this.classList.add('fallback-logo')"
                />
            
                <!-- Left Section: Product Details -->
                <div class="bottom-fixed-details">
                    <div class="bottominfo"><span class="bold">{{ data?.brand?.name }}</span></div>
                    <div class="partname">{{ data.name }}</div>
                </div>
            
                <!-- Right Section: Price Details -->
                <div class="price-details">
                <div class="pricedetails-mrp">
                    <span class="linethroughmrp" >MRP</span>
                    <span class="line-through" *ngIf="data.mrp > data.sellingPrice"  > ₹{{ data.mrp | number }}</span>
                </div>
                <div class="linethrough-mrp">
                    <span class="mrp" > ₹{{ data.sellingPrice | number }}</span>
                    <span class="discount" *ngIf="data.discount > 0">( You Save ₹{{ data.discount | number:'1.2-2'}} )</span>
                    <span class="offer"
                        *ngIf="data.discount > 0"
                    >
                        {{ discountType }} off
                </span>
                    </div>
                </div>
            </div>
            
            <!-- Add to Cart and Quantity Controls -->
            <div class="bottom-fixed-actions">
                <div *ngIf="cartList[0] && cartList[0][data.key]">
                    <div class="spare-add-cart" style="width: 100%;">
                        <div  class="btn-group"*ngIf="data.key == cartList[0][data.key].key && cartList[0][data.key].cart_qty > 0">
                            <button class="quantity-btn" (click)="removeItem(cartList[0][data.key].cart_qty, data.key)">
                                <mat-icon class="sidebuttons">remove</mat-icon>
                            </button>
                            <input type="text" [(ngModel)]="cartList[0][data.key].cart_qty" readonly />
                            <button class="quantity-btn" (click)="addItem(cartList[0][data.key].cart_qty, data.key)">
                                <mat-icon class="sidebutton">add</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <button
                *ngIf="cartList.length <= 0"
                class="add-to-cart-btn"
                (click)="addCart(1)"
                >
                Add to Cart
                </button>
                <button
                *ngIf="cartList.length > 0 && !cartList[0][data.key]"
                class="add-to-cart-btn"
                (click)="addCart(1)"
                >
                Add to Cart
                </button>
            </div>
        </div>


        <div class="mobile-bottom-fixed" *ngIf="isMobile && isAvailable">
            <!-- Add to Cart and Quantity Controls -->
            <div class="bottom-fixed-actions">
                <!-- If product is in the cart -->
                <div *ngIf="cartList[0] && cartList[0][data.key]">
                <div class="btncartdiv">
                    <div class="btn-group">
                    <button
                        class="quantity-btn"
                        (click)="removeItem(cartList[0][data.key].cart_qty, data.key)">
                        <mat-icon class="sidebuttons">remove</mat-icon>
                    </button>
                    <input
                        type="text"
                        [(ngModel)]="cartList[0][data.key].cart_qty"
                        readonly
                    />
                    <button
                        class="quantity-btn"
                        (click)="addItem(cartList[0][data.key].cart_qty, data.key)" >
                        <mat-icon class="sidebutton">add</mat-icon>
                    </button>
                    </div>
                </div>


                <!-- ________________________________________________________ -->
                <!-- <div class="viewcartbtn">
                    <div class="viewcartbtnttl">
                        <div class="viewcartbtnitems"> -->
                            <!-- <div class="noofitems"> {{ cartList[0][data.key].cart_qty }} Items </div> -->
                            <!-- <div class="noofitems"> {{ cartList[0][data.key].cart_qty }}  {{ cartList[0][data.key].cart_qty > 1 ? 'Items' : 'Item' }}</div>      -->
                            <!-- <div class="price" *ngIf="data.sellingPrice > 0">
                                <div class="grand-total">&#8377;{{cartGrandTotal | number:'1.2-2'}}</div>
                            </div> -->
                            <!-- <span class="price" > ₹{{ data.sellingPrice | number }}</span>
                        </div> 
                        <button class="view-cart-btn" (click)="goToCart()">View Cart</button>   
                    </div>
                </div> -->
                <div class="viewcartbtn">
                    <div class="viewcartbtnttl">
                        <div class="viewcartbtnitems">
                            <div class="noofitems">{{ cartList[0][data.key].cart_qty }} {{ cartList[0][data.key].cart_qty > 1 ? 'Items' : 'Item' }}</div>
                            <!-- <span class="price">₹{{ data.sellingPrice | number }}</span> -->
                            <span class="price">₹{{ (data.sellingPrice * cartList[0][data.key].cart_qty) | number:'1.2-2' }}</span>
                        </div>
                    </div>
                    <button class="view-cart-btn" (click)="goToCart()">View Cart</button>
                </div>
                
                <!-- ________________________________________________________________ -->
                </div>
                <!-- If product is NOT in the cart -->
                <button
                *ngIf="!cartList[0] || !cartList[0][data.key]"
                class="add-to-cart-btn"
                (click)="addCart(1)"
                >
                Add to Cart
                </button>
            </div>
        </div>
        <div class="mobile-bottom-fixed" *ngIf="isMobile && !isAvailable">
            <!-- Add to Request Wishlist and Quantity Controls -->
            <div class="bottom-fixed-actions">
                <!-- If product is in the wishlist -->
                <div *ngIf="wishlistList[0] && wishlistList[0][data.key]">
                <div class="btncartdiv">
                    <div class="btn-group">
                    <button
                        class="quantity-btn"
                        (click)="removeWishlistItem(wishlistList[0][data.key].cart_qty, data.key)">
                        <mat-icon class="sidebuttons">remove</mat-icon>
                    </button>
                    <input
                        type="text"
                        [(ngModel)]="wishlistList[0][data.key].cart_qty"
                        readonly
                    />
                    <button
                        class="quantity-btn"
                        (click)="addWishlistItem(wishlistList[0][data.key].cart_qty, data.key)" >
                        <mat-icon class="sidebutton">add</mat-icon>
                    </button>
                    </div>
                </div>

                <div class="viewcartbtn">
                    <div class="viewcartbtnttl">
                        <div class="viewcartbtnitems">
                            <div class="noofitems">{{ wishlistList[0][data.key].cart_qty }} {{ wishlistList[0][data.key].cart_qty > 1 ? 'Items' : 'Item' }}</div>
                            <!-- <span class="price">₹{{ data.sellingPrice | number }}</span> -->
                                   <span class="price">₹{{ (data.sellingPrice * wishlistList[0][data.key].cart_qty) | number:'1.2-2' }}</span>

                        </div>
                    </div>
                    <button class="view-cart-btn" (click)="goToWishlist()">View Wishlist</button>
                </div>
                </div>
                <!-- If product is NOT in the wishlist -->
                <button
                *ngIf="!wishlistList[0] || !wishlistList[0][data.key]"
                class="add-to-cart-btn"
                (click)="addToRequestWishlist(data)"
                >
                Add to Request Wishlist
                </button>
            </div>
        </div>

        <!-- <div class="mobile-top-fixed"*ngIf="isMobile">
            <div class="arrowbackandpartname">
                <i class="material-icons-arrowback-new" (click)="goBack()">arrow_back</i>
                <div class="partname">{{ data.name }}</div>
            </div>
            <span class="mrp" > ₹{{ data.sellingPrice | number }}</span>
            <span class="offer"*ngIf="data.discount > 0"> {{ discountType }} off</span>
        </div> -->
    </div>
<!-- </div> -->



<!-- ================= EMPTY STATE UI ================= -->
<div *ngIf="!loading && showEmptyState" class="product-empty-wrapper-main">
  <h1 class="product-empty-page-title">
    Service Kit Not Found
  </h1>
  <div class="product-empty-wrapper">
        <div class="product-empty-illustration">
            <img [src]="emptyList" alt="Service Kit Not Found" />
        </div>
        <h2 class="product-empty-title">
            Service kit unavailable!
        </h2>

        <p class="product-empty-subtitle">
            Inconvenience is regretted
        </p>

        <p class="product-empty-info">
            We will notify you once it is available
        </p>

        <button class="product-empty-primary-btn"
                (click)="goToVariantList()">
            Browse Other Parts
        </button>
    </div>
</div>


<ng-container #intstantorder></ng-container>
